// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts,js_import_style=legacy_commonjs"
// @generated from file fusebase/app_analytics/v1/users.proto (package fusebase.app_analytics.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });

const { proto3 } = require("@bufbuild/protobuf");
const { EventContextFilter } = require("./event_context_pb.js");

/**
 * @generated from enum fusebase.app_analytics.v1.DeviceType
 */
const DeviceType = /*@__PURE__*/ proto3.makeEnum(
  "fusebase.app_analytics.v1.DeviceType",
  [
    {no: 0, name: "DEVICE_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "DEVICE_TYPE_DESKTOP", localName: "DESKTOP"},
    {no: 2, name: "DEVICE_TYPE_MOBILE", localName: "MOBILE"},
    {no: 3, name: "DEVICE_TYPE_BOT", localName: "BOT"},
  ],
);

/**
 * @generated from enum fusebase.app_analytics.v1.UserSort
 */
const UserSort = /*@__PURE__*/ proto3.makeEnum(
  "fusebase.app_analytics.v1.UserSort",
  [
    {no: 0, name: "USER_SORT_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "USER_SORT_EVENTS_COUNT", localName: "EVENTS_COUNT"},
  ],
);

/**
 * @generated from message fusebase.app_analytics.v1.RawUser
 */
const RawUser = /*@__PURE__*/ proto3.makeMessageType(
  "fusebase.app_analytics.v1.RawUser",
  () => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fusebase.app_analytics.v1.User
 */
const User = /*@__PURE__*/ proto3.makeMessageType(
  "fusebase.app_analytics.v1.User",
  () => [
    { no: 1, name: "raw_user", kind: "message", T: RawUser },
    { no: 2, name: "device_type", kind: "enum", T: proto3.getEnumType(DeviceType) },
    { no: 3, name: "country_iso_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "ip_address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "is_active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fusebase.app_analytics.v1.UserFilter
 */
const UserFilter = /*@__PURE__*/ proto3.makeMessageType(
  "fusebase.app_analytics.v1.UserFilter",
  () => [
    { no: 1, name: "context_filter", kind: "message", T: EventContextFilter },
    { no: 2, name: "sort", kind: "enum", T: proto3.getEnumType(UserSort) },
    { no: 3, name: "sort_desc", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fusebase.app_analytics.v1.ListUsersRequest
 */
const ListUsersRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fusebase.app_analytics.v1.ListUsersRequest",
  () => [
    { no: 1, name: "filter", kind: "message", T: UserFilter },
    { no: 100, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 101, name: "page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fusebase.app_analytics.v1.ListUsersResponse
 */
const ListUsersResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fusebase.app_analytics.v1.ListUsersResponse",
  () => [
    { no: 1, name: "users", kind: "message", T: User, repeated: true },
    { no: 2, name: "events_count", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 5 /* ScalarType.INT32 */} },
    { no: 100, name: "next_page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fusebase.app_analytics.v1.ListUserAvatarsRequest
 */
const ListUserAvatarsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fusebase.app_analytics.v1.ListUserAvatarsRequest",
  () => [
    { no: 1, name: "user_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message fusebase.app_analytics.v1.ListUserAvatarsResponse
 */
const ListUserAvatarsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fusebase.app_analytics.v1.ListUserAvatarsResponse",
  () => [
    { no: 1, name: "avatar_urls", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
  ],
);

/**
 * @generated from message fusebase.app_analytics.v1.GetUsersRequest
 */
const GetUsersRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fusebase.app_analytics.v1.GetUsersRequest",
  () => [
    { no: 1, name: "user_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 100, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 101, name: "page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fusebase.app_analytics.v1.GetUsersResponse
 */
const GetUsersResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fusebase.app_analytics.v1.GetUsersResponse",
  () => [
    { no: 1, name: "users", kind: "message", T: User, repeated: true },
    { no: 100, name: "next_page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);


exports.DeviceType = DeviceType;
exports.UserSort = UserSort;
exports.RawUser = RawUser;
exports.User = User;
exports.UserFilter = UserFilter;
exports.ListUsersRequest = ListUsersRequest;
exports.ListUsersResponse = ListUsersResponse;
exports.ListUserAvatarsRequest = ListUserAvatarsRequest;
exports.ListUserAvatarsResponse = ListUserAvatarsResponse;
exports.GetUsersRequest = GetUsersRequest;
exports.GetUsersResponse = GetUsersResponse;
